export const REQUEST_ADS_LINK = 'https://usekanda.typeform.com/kanda-adverts';
